/*
Copyright 2023, 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only
Please see LICENSE in the repository root for full details.
*/

export enum E2eeType {
  NONE = 0,
  PER_PARTICIPANT = 1,
  SHARED_KEY = 2,
}
